// 中文
module.exports = {
    language: {
        name: 'Language',
        en: 'English',
        cn: '中文'
    },
    response: {
        c_401: 'No access right now, please contact the administrator',
        c_403: 'Forbidden, please contact the administrator',
        c_404: 'Network is weak, please try again later',
        c_405: "Your identity has expired, Please login again",
        c_4040: 'Not Found',
        c_500: 'System error',
        c_502: 'Network Error',
        c_503: 'System under maintenance',
        timeout: 'Request timed out<br>Please try again later',
        network_error: 'I lost my network<br>Please check the network',
    },
    list: {
        no_data: 'No data record',
        pull_down: 'Pull down to refresh',
        songkai: 'Release to refresh immediately',
        refresh_ing: 'Refreshing data',
        pull_up: 'Pull up to load more',
        loading: 'Loading',
        no_more: 'No more',
    },
    toast: {
        title: "Tips",
        confirm_bth_text: "Confirm",
        cancel_bth_text: "Cancel",
        close_bth_text: "Close",
    }
}